import(/* webpackMode: "eager" */ "/app/components/AgentCard.js");
import(/* webpackMode: "eager" */ "/app/components/ContactCard.js");
import(/* webpackMode: "eager" */ "/app/components/CurrencySymbol.js");
import(/* webpackMode: "eager" */ "/app/components/FooterPopularLinks.js");
import(/* webpackMode: "eager" */ "/app/components/HtmlComponent.js");
import(/* webpackMode: "eager" */ "/app/components/LdJson/BreadcrumbsLdJson.js");
import(/* webpackMode: "eager" */ "/app/components/LdJson/PropertyLdJson.js");
import(/* webpackMode: "eager" */ "/app/components/LinkComponent.js");
import(/* webpackMode: "eager" */ "/app/components/Location.js");
import(/* webpackMode: "eager" */ "/app/components/Nav.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyContact.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyFloorplansGallery.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyGallery.js");
import(/* webpackMode: "eager" */ "/app/components/RecommendedProperties.js");
import(/* webpackMode: "eager" */ "/app/components/ShareButton.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")